import React from 'react'
import { logoEduca } from '../../assets';
import { Chatbot } from "../../components/Chatbot/Chatbot";
import { AdminMenu , Logout } from '../../components/Admin/AdminLayout';

import "./AdminLayout.scss";

export function AdminLayout({ children }) {
  return (
    <div className='admin-layout'>
      <div className='admin-layout__left'>
      

        {/* CONTENIDO POR ENCIMA */}
        <div className="admin-layout__left-content">
          <img src={logoEduca.logoE360} alt="logoE360" className='logo' />
          <AdminMenu />
        </div>
      </div>

      <div className='admin-layout__right'>
        <div className='admin-layout__right-header'> 
          <Logout/>
        </div>
        <div className='admin-layout__right-content'>
          {children}
        </div>
      </div>

      <Chatbot />
    </div>
  );
}
